import { AlmeUIResponse} from '@alme/ui-web/types/response';
import { Store } from "redux";
import {EntryOriginTypesV5} from '@alme/api-ts/Alme/EntryOriginTypes';
import {settings} from '@alme/ui-web/settings/settings-util';
import {AlmeResponseV5} from '@alme/types/response/AlmeResponse';
import {ResponseAction} from '@alme/types/response/ResponseAction';
import ResponseActionHandler from '@alme/ui-web/types/response-action-handler';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import LaunchOffersAppEventUtility from '../launch-offers-appevent-utility/launchOffersAppEventUtility';

interface TriggerAppEventResponseAction extends ResponseAction{
    AppEventName: string;
    parameters: { [key: string]: unknown };
}

export default class TriggerAppEventResponseHandler extends ResponseActionHandler{
    _launchOffersAppEventUtility: LaunchOffersAppEventUtility;

    constructor(passedSettings: typeof settings, launchOffersAppEventUtility: LaunchOffersAppEventUtility) {
        super(["AppeventRequest", "ConverseRequest", "RequestUnitRequest", "GetNotificationRequest"], ["TriggerAppEvent"], passedSettings);
        this._launchOffersAppEventUtility = launchOffersAppEventUtility;
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    processResponse(response: AlmeUIResponse): AlmeUIResponse {

        const appEvent: TriggerAppEventResponseAction = this.getFirstResponseActionNamed(response as AlmeResponseV5) as TriggerAppEventResponseAction;

        switch(appEvent.AppEventName.toLowerCase()){
            case "HypeOffer".toLowerCase(): {
                this._launchOffersAppEventUtility.sendLaunchOfferAppEvent("HypeOffer");
                break;
            }
            case "AssistTicketUpdate".toLowerCase(): {
                this._launchOffersAppEventUtility.sendLaunchOfferAppEvent("AssistTicketUpdate");
                break;
            }
            default: { 
                this.sendNamedAppEvent(appEvent);
                break; 
             } 
        }

        return response;
    }

    private sendNamedAppEvent(appEvent: TriggerAppEventResponseAction) {
        const input = {
            messageType: this._settings.messageConstants.appeventRequest,
            eventName: appEvent.AppEventName,
            origin: this._settings.originConstants.internal as EntryOriginTypesV5,
            parameters: appEvent.parameters ?? {},
        };

        sendRequest(input);
    }

}


// WEBPACK FOOTER //
// ./modules/response-handler-trigger-appevents/response-handler-trigger-appevents.ts